import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 9,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
  },

  /* HEADER */

  header: {
    textAlign: "center",
    marginBottom: 10,
  },

  quotationTitle: {
    fontSize: 12,
    fontWeight: "bold",
    textDecoration: "underline",
    marginBottom: 5,
    letterSpacing: 1,
  },

  company: {
    fontSize: 19,
    fontWeight: "bold",
    marginBottom: 3,
  },

  smallText: {
    fontSize: 9,
    lineHeight: 1.5,
  },

  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginTop: 8,
  },

  /* TOP INFO */

  /* TOP INFO */

  infoRow: {
    flexDirection: "row",
    borderWidth: 1,
    borderBottomWidth: 0,
  },

  infoBox: {
    flex: 1,
    padding: 6,
    borderRightWidth: 1,
  },

  /* CUSTOMER */

  customerRow: {
    flexDirection: "row",
    borderWidth: 1,
  },

  customerBox: {
    flex: 1,
    padding: 8,
    borderRightWidth: 1,
    minHeight: 70,
  },

  label: {
    fontWeight: "bold",
    marginBottom: 4,
    fontSize: 10,
  },
  infoText: {
    fontSize: 9,
    fontWeight: "bold",
  },



  customerText: {
    marginBottom: 3,
    lineHeight: 1.4,
  },

  /* TABLE */

  table: {
    width: "100%",
    borderWidth: 1,
    borderTopWidth: 0,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#eeeeee",
    borderBottomWidth: 1,
    alignItems: "center",
    minHeight: 26,
  },

  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    alignItems: "center",
    minHeight: 24,
  },

  headerText: {
    fontWeight: "bold",
    fontSize: 8.5,
  },

  /* COLUMNS */

  sno: {
    width: "7%",
    padding: 4,
    borderRightWidth: 1,
    textAlign: "center",
  },

  product: {
    width: "35%",
    padding: 4,
    borderRightWidth: 1,
  },

  qty: {
    width: "12%",
    padding: 4,
    borderRightWidth: 1,
    textAlign: "center",
  },

  sqft: {
    width: "12%",
    padding: 4,
    borderRightWidth: 1,
    textAlign: "center",
  },

  rate: {
    width: "14%",
    padding: 4,
    borderRightWidth: 1,
    textAlign: "right",
  },

  amount: {
    width: "20%",
    padding: 4,
    textAlign: "right",
  },

  /* TOTAL */

  totalWrapper: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
  },

  totalRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
  },

  totalLabel: {
    flex: 1,
    padding: 7,
    textAlign: "right",
    borderRightWidth: 1,
    fontWeight: "bold",
    fontSize: 10,
  },

  totalValue: {
    width: 120,
    padding: 7,
    textAlign: "right",
    fontWeight: "bold",
    fontSize: 10,
  },

  /* FOOTER */

  footer: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  terms: {
    width: "60%",
  },

  termsTitle: {
    fontWeight: "bold",
    marginBottom: 5,
    textDecoration: "underline",
  },

  termsText: {
    marginBottom: 3,
    lineHeight: 1.5,
  },

  signBox: {
    width: "35%",
    textAlign: "center",
  },

  signCompany: {
    fontWeight: "bold",
  },

  signText: {
    marginTop: 45,
    fontSize: 9,
    fontWeight: "bold",
  },
});

const QuotationPDF = ({ order, items }) => {

  const total = items.reduce(
    (sum, item) =>
      sum +
      Number(item.price) *
      Number(item.total_area || 1),
    0
  );

  const discount =
  Number(order.discount || 0);

const grandTotal =
  total - discount;

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* HEADER */}

        <View style={styles.header}>

          <Text style={styles.quotationTitle}>
            QUOTATION
          </Text>

          <Text style={styles.company}>
            A.K. CERAMIC WORLD
          </Text>

          <Text style={styles.smallText}>
            70, Palayamkottai Taluk, V.G Panneer Das Town
            Bye Pass Road, Reddiyarpatti, Tirunelveli - 7
          </Text>

          <Text style={styles.smallText}>
            GSTIN : 33ACDFA2032P1ZL
          </Text>

          <Text style={styles.smallText}>
            Mobile : 97507 92020, 63746 07590
          </Text>

          <View style={styles.divider} />

        </View>

        {/* TOP INFO */}

        <View style={styles.infoRow}>

          <View style={styles.infoBox}>
            <Text style={styles.infoText}>
              Quotation No : QT-{order.order_id}
            </Text>
          </View>

          <View
            style={[
              styles.infoBox,
              { borderRightWidth: 0 },
            ]}
          >
            <Text style={styles.infoText}>
              Date : {order.date || ""}
            </Text>
          </View>

        </View>

        {/* CUSTOMER DETAILS */}

        <View style={styles.customerRow}>

          <View style={styles.customerBox}>

            <Text style={styles.label}>
              CUSTOMER DETAILS
            </Text>

            <Text style={styles.customerText}>
              Name : {order.name}
            </Text>

            <Text style={styles.customerText}>
              Mobile : {order.phone}
            </Text>

            <Text style={styles.customerText}>
              Address :
            </Text>

            <Text style={styles.customerText}>
              {order.address || ""}
            </Text>

          </View>

          <View
            style={[
              styles.customerBox,
              { borderRightWidth: 0 },
            ]}
          >

            <Text style={styles.label}>
              NOTES
            </Text>

            <Text style={styles.customerText}>
              • Prices may vary at billing time
            </Text>

            <Text style={styles.customerText}>
              • Transportation extra if applicable
            </Text>

            <Text style={styles.customerText}>
              • Valid for 7 days only
            </Text>

          </View>

        </View>

        {/* TABLE */}

        <View style={styles.table}>

          {/* TABLE HEADER */}

          <View style={styles.tableHeader}>

            <Text style={[styles.sno, styles.headerText]}>
              S.NO
            </Text>

            <Text style={[styles.product, styles.headerText]}>
              PRODUCT
            </Text>

            <Text style={[styles.qty, styles.headerText]}>
              BOX
            </Text>

            <Text style={[styles.sqft, styles.headerText]}>
              SQFT
            </Text>

            <Text style={[styles.rate, styles.headerText]}>
              RATE
            </Text>

            <Text style={[styles.amount, styles.headerText]}>
              AMOUNT
            </Text>

          </View>

          {/* ITEMS */}

          {items.map((item, index) => (

            <View key={index} style={styles.row}>

              <Text style={styles.sno}>
                {index + 1}
              </Text>

              <Text style={styles.product}>
                {item.product_name}
              </Text>

              <Text style={styles.qty}>
                {item.qty || 1}
              </Text>

              <Text style={styles.sqft}>
                {item.total_area || 1}
              </Text>

              <Text style={styles.rate}>
                ₹ {Number(item.price).toFixed(2)}
              </Text>

              <Text style={styles.amount}>
                ₹ {(
                  Number(item.price) *
                  Number(item.total_area || 1)
                ).toFixed(2)}
              </Text>

            </View>

          ))}

          {/* EMPTY ROWS */}

          {Array.from({
            length: Math.max(0, 10 - items.length),
          }).map((_, i) => (

            <View key={i} style={styles.row}>

              <Text style={styles.sno}> </Text>
              <Text style={styles.product}> </Text>
              <Text style={styles.qty}> </Text>
              <Text style={styles.sqft}> </Text>
              <Text style={styles.rate}> </Text>
              <Text style={styles.amount}> </Text>

            </View>

          ))}

        </View>

        {/* TOTAL */}
<View style={styles.totalWrapper}>

  {/* SUB TOTAL */}
  <View style={styles.totalRow}>

    <Text style={styles.totalLabel}>
      SUB TOTAL
    </Text>

    <Text style={styles.totalValue}>
      ₹ {total.toFixed(2)}
    </Text>

  </View>

  {/* DISCOUNT */}
  <View style={styles.totalRow}>

    <Text style={styles.totalLabel}>
      DISCOUNT
    </Text>

    <Text style={styles.totalValue}>
      ₹ {discount.toFixed(2)}
    </Text>

  </View>

  {/* GRAND TOTAL */}
  <View style={styles.totalRow}>

    <Text style={styles.totalLabel}>
      GRAND TOTAL
    </Text>

    <Text style={styles.totalValue}>
      ₹ {grandTotal.toFixed(2)}
    </Text>

  </View>

</View>

        {/* FOOTER */}

        <View style={styles.footer}>

          <View style={styles.terms}>

            <Text style={styles.termsTitle}>
              Terms & Conditions
            </Text>

            <Text style={styles.termsText}>
              1. Goods once sold cannot be returned.
            </Text>

            <Text style={styles.termsText}>
              2. Delivery charges extra if applicable.
            </Text>

            <Text style={styles.termsText}>
              3. Quotation valid for limited period only.
            </Text>

          </View>

          <View style={styles.signBox}>

            <Text style={styles.signCompany}>
              For A.K. CERAMIC WORLD
            </Text>

            <Text style={styles.signText}>
              Authorised Signatory
            </Text>

          </View>

        </View>

      </Page>
    </Document>
  );
};

export default QuotationPDF;